module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-results-holder"
  }, [_c('transition-group', {
    attrs: {
      "css": false
    },
    on: {
      "afterEnter": _vm.enterEl,
      "leave": _vm.leaveEl
    }
  }, _vm._l((_vm.$store.state.searchResults), function(searchResults, searchResultsIndex) {
    return _c('div', {
      key: searchResults.name + searchResults.artist,
      staticClass: "search-results",
      class: {
        'search-results--active': searchResults.active, 'search-results__album': searchResults.mbid !== '' ? _vm.searchType : ''
      },
      on: {
        "click": function($event) {
          _vm.toggleClass(searchResults, searchResultsIndex)
        }
      }
    }, [(_vm.$store.state.searchType === 'artist') ? _c('router-link', {
      attrs: {
        "to": ("/bio/" + (encodeURI(searchResults.name)))
      }
    }, [_c('p', {
      staticClass: "search-results__name"
    }, [_vm._v(_vm._s(searchResults.name))]), _vm._v(" "), (searchResults.image[3]['#text'] !== '') ? _c('img', {
      attrs: {
        "src": searchResults.image[3]['#text']
      }
    }) : _c('img', {
      attrs: {
        "src": require("@/assets/img/default.png")
      }
    })]) : _c('div', {
      staticClass: "search-results__album"
    }, [_c('p', {
      staticClass: "search-results__name"
    }, [_vm._v(_vm._s(searchResults.name))]), _vm._v(" "), (searchResults.image[3]['#text'] !== '') ? _c('img', {
      attrs: {
        "src": searchResults.image[3]['#text']
      }
    }) : _c('img', {
      attrs: {
        "src": require("@/assets/img/default.png")
      }
    })]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "show-tracks"
      }
    }, [(searchResults.active) ? _c('div', {
      staticClass: "tracks-holder"
    }, [_c('h3', [_vm._v(_vm._s(searchResults.name))]), _vm._v(" "), _vm._o(_c('VuePerfectScrollbar', {
      staticClass: "scroll-area",
      attrs: {
        "settings": _vm.settings
      }
    }, [_c('track-list')], 1), 0, searchResults.name + searchResults.artist)], 1) : _vm._e()])], 1)
  })), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-in"
    }
  }, [(_vm.$store.state.nextLink > 1) ? _c('button', {
    staticClass: "search-results-holder__load-more",
    on: {
      "click": _vm.loadMore
    }
  }, [_vm._v("Load More")]) : _vm._e()]), _vm._v(" "), (_vm.$store.state.noResults) ? _c('p', {
    staticClass: "search-resultss-holder__sorry-message"
  }, [_vm._v("\n    Sorry no results for "), _c('span', [_vm._v(_vm._s(_vm.$store.state.searchTearm))]), _vm._v("!\n  ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c114b16"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search-Results.vue
// module id = 61
// module chunks = 1